import { render, staticRenderFns } from "./CommentsHeader.vue?vue&type=template&id=1a7d0291&scoped=true"
import script from "./CommentsHeader.vue?vue&type=script&lang=js"
export * from "./CommentsHeader.vue?vue&type=script&lang=js"
import style0 from "./CommentsHeader.vue?vue&type=style&index=0&id=1a7d0291&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a7d0291",
  null
  
)

export default component.exports